<template>
  <div>
    <v-card
      v-if="seeAlsoList && seeAlsoList.length"
      flat
      class="mt-4"
      :class="$vuetify.breakpoint.smAndUp ? 'ml-6' : 'mx-1'"
    >
      <v-card-text class="pa-2 darkerCardText">
        <div class="overline">See Also</div>
        <span v-for="(item, index) in seeAlsoList" :key="index">
          <span v-html="addIcdLinks(item) + punctuation(index)"> </span>
        </span>

        <!-- <ul>
          <li
            v-for="(item, index) in itemsWithTruncate"
            :key="index"
            v-html="addIcdLinks(item)"
          ></li>
          <v-fade-transition>
            <div v-if="truncate && hiddenCount > 0">
              <v-btn text small color="primary" @click="truncate = false"
                >. . . show {{ hiddenCount }} more</v-btn
              >
            </div>
          </v-fade-transition>
        </ul> -->
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import FormatIcdMixin from "@/assets/js/icd/FormatIcdMixin";
export default {
  name: "IcdSeeAlso",
  mixins: [FormatIcdMixin],
  props: {
    codes: null,
  },
  data: function () {
    return {
      truncate: true,
      maxItems: 3,
    };
  },
  methods: {
    punctuation(index) {
      return index == this.seeAlsoCount - 1 ? "." : ",  ";
    },
  },
  computed: {
    seeAlsoCount: function () {
      if (!this.seeAlsoList) return null;
      return this.seeAlsoList.length;
    },

    seeAlsoList: function () {
      let rtn = [];
      if (!this.codes) return null;
      let codeKeys = Object.keys(this.codes);
      // console.log(codeKeys);
      codeKeys.forEach((key) => {
        let obj = this.codes[key];
        let codeExclusions = [];
        if (obj.notes && obj.notes["Exclusions 1"]) {
          obj.notes["Exclusions 1"].forEach(function (row) {
            codeExclusions.push(row);
          });
        }
        if (obj.notes && obj.notes["Exclusions 2"]) {
          obj.notes["Exclusions 2"].forEach(function (row) {
            codeExclusions.push(row);
          });
        }

        // finds codes in the exclusions and makes them a "see also" item IF the code isn't already included on the current page.
        codeExclusions.forEach((item) => {
          // console.log(item);
          let match = item.match(/[A-Za-z]\d\d\.?\d{0,3}/i);
          //console.log(match);
          if (match && match[0]) {
            let code3 = this.codeParent(match[0], 3); // from mixin
            // console.log(code3);
            if (!codeKeys.includes(code3) && !rtn.includes(item))
              rtn.push(item);
          }
        });
      });
      return rtn;
    },
  },
};
</script>

<style scoped></style>
